import React from 'react';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import './ImageBox.css';

const ImageBox = props => {
  const { onDrop, preview } = props;
  return (
    <div style={{ display: 'grid', alignItems: 'center', justifyContent: 'center' }}>
      {!preview && (
        <div onClick={onDrop} id="new" className="add-event">
          <Fab id="new" size="large" aria-label="Add" label="test">
            <AddIcon id="new" size="large" color="action" />
          </Fab>
        </div>
      )}
      {preview}
    </div>
  );
};

export default ImageBox;
